import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MenuPdfService {
  constructor(private http: HttpClient) {}

  downloadMenuPdf(hotelId: string): Observable<Blob> {
    return this.http.get(
      `${environment.apiUrl}/api/udaan/download-factsheet-pdf/${hotelId}`,
      {
        responseType: 'blob',
        withCredentials: true,
      }
    );
  }
}
